// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"631":"0013755c","774":"e3ce1de4","787":"1fee1fb8","854":"c68ec817","858":"9f41850a"}[chunkId] + ".chunk.js";
};